"use strict";
appClientService.$inject = ["topology"];
Object.defineProperty(exports, "__esModule", { value: true });
exports.appClientService = void 0;
var app_settings_client_1 = require("@wix/app-settings-client");
/* @ngInject */
function appClientService(topology) {
    return app_settings_client_1.appClient({ scope: app_settings_client_1.Scope.COMPONENT, cdnUrl: topology.appSettingsCDNClientBaseUrl });
}
exports.appClientService = appClientService;
